module.exports = __webpack_public_path__ + "img/04.a7d6a6fd.jpg";